//* 组件库
import type { UiSimplebar, UiTooltipFunction } from "various-ui";
//* 私有组件
import type ModuleInfo from "../components/info/index.vue";
import type { ExtractPropTypes } from "vue";
//* 原始数据
export interface DrawOriginData {
    strand: boolean;
    chr_start_pos: number;
    sequence: string;
    coordinate: DrawCoordinate[];
}

//* 坐标数据
export interface DrawCoordinate {
    number: number;
    start: number;
    size: number;
    type: string;
    name: string;
    end: number;
    utr: number[][];
    key?: number;
    intron_type?: string;
}

//* 序列数据
export interface DrawSequence {
    sites: { cds: string | number; genome: string | number };
    char: string;
    site: number;
    area: string;
    type: string;
    name?: string;
    codon?: string;
    number: number;
    codons?: DrawSequence[];
    mutations?: {
        count: number;
        data: {
            [name: string]: DrawMutation[];
        };
    };
}

//* 突变位点数据
export interface DrawMutation {
    id: number;
    name: string;
    site: number;
    status: string;
}

//* 突变位点数据列表
export interface DrawMutations {
    [name: string]: {
        count: number;
        data: {
            [name: string]: DrawMutation[];
        };
    };
}

//* 绘图初始化数据
export interface DrawInitData {
    size: number;
    origin: DrawOriginData;
    radius?: number[][];
    message: string;
    selects?: string[];
    mutations: DrawMutations;
}

//* 绘图初始化节点
export interface DrawInitOptions {
    setup?: (data: any) => void;
    container: HTMLDivElement;
    simplebar: InstanceType<typeof UiSimplebar>;
    tips: InstanceType<typeof UiTooltipFunction>;
    info: InstanceType<typeof ModuleInfo>;
}

//* 序列Tips数据
export interface DrawTips {
    data: any;
    type: string;
    site: number;
    name?: string;
    mutations?: {
        count: number;
        data: {
            [name: string]: DrawMutation[];
        };
    };
}

//* 序列绘制的颜色
export interface DrawCharColors {
    rect: string;
    color: string;
    active: string;
    selector: string;
    background: string;
}

export interface DrawEmitNextData {
    cds: string;
    site: string;
    mode: "Pathogenicity-Predictor" | "RNA-Splicer";
    carry: boolean;
}

export interface DrawEmitInfoData {
    ids: number[];
    mrna: string;
    name: string;
    site: number;
    data: { is: boolean; cds: string; site: string; carry: boolean };
    codon: string;
}

//* 响应事件声明
export const DrawEmitsOption = {
    codon: (_data: any) => true,
    info: (_data: DrawEmitInfoData) => true,
    next: (_data: DrawEmitNextData) => true,
};
